import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { MomentFormats, toValidateIfDate, useDate } from '../../../../common/utils/date';
import Tooltip from '../kendo/Tooltip';
import { CustomGridCellProps } from '../kendo/types';

export const CommonCell = ({
  dataItem,
  field,
  rowType,
  colSpan,
  style,
  className,
  columnIndex,
  cellRowClick,
}: CustomGridCellProps) => {
  const value = get(dataItem, field || '');
  const toCheckIfDate = toValidateIfDate(value);
  const { getFormattedDateString, formatDisplayDate } = useDate();
  let formattedValue = toCheckIfDate
    ? getFormattedDateString(value, MomentFormats.MonthDateYear)
    : value;

  if (field === 'precalc.lhr_end_accepted_quantity' && value === -1) {
    formattedValue = 'N/A';
  }

  if (Array.isArray(value)) {
    formattedValue = value.join(', ');
  }

  const cellClickEvent = () => {
    if (!cellRowClick) { return; }
    cellRowClick({ dataItem });
  };

  if (rowType === 'groupHeader') {
    return null;
  }

  if (formattedValue && moment.utc(formattedValue, moment.ISO_8601, true).isValid()) {
    formattedValue = formatDisplayDate(formattedValue);
  }

  return (
    <td
      colSpan={colSpan}
      style={style}
      role="gridcell"
      className={className}
      data-grid-col-index={columnIndex}
      onClick={cellClickEvent}
    >
      <Tooltip data={formattedValue} />
    </td>
  );
};
